// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{  }} i
*/
export const messageBroadcast_donateMore = (i) => `Feel free to donate more if you like our work here. 😉`